"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetService = void 0;
const apiRoutes_1 = require("../../utils/apiRoutes");
const Base_1 = require("../Base");
class WidgetService extends Base_1.BaseService {
    fetchWidgetSettings(params) {
        return this.request({
            url: (0, apiRoutes_1.widgetSettingsApiUrl)({ msid: params === null || params === void 0 ? void 0 : params.msid }),
            method: 'get',
        });
    }
}
exports.WidgetService = WidgetService;
//# sourceMappingURL=index.js.map